module.exports = __webpack_public_path__ + "files/414f12d6e721827f0c6f4d41a43603da.png";